import { getStatusConfig } from "../utils/enums";

export const Select = ({
  label,
  isRequired = false,
  isDisabled = false,
  isEditMode = false,
  value,
  onChange,
  options = [],
  placeholder = "-- Select Data --",
  allowSelectAll = false,
  className = "",
  parentClassName = "",
  error = "",
  errorMessage = "",
  ...props
}) => {
  const disabled = isEditMode || isDisabled;

  // Combine options with "All" if allowed - use string "0" for consistency
  const finalOptions = [
    ...(allowSelectAll ? [{ value: "0", label: "All" }] : []),
    ...options,
  ];

  return (
    <div className={`mb-1 ${parentClassName}`}>
      {/* Label */}
      {label && (
        <label className="mb-1.5 block text-sm font-medium text-gray-600">
          {label}
          {isRequired && <span className="ml-1 text-red-500">*</span>}
        </label>
      )}

      {/* Select */}
      <select
        value={value || ""}
        onChange={onChange}
        disabled={disabled}
        className={`w-full box-border border border-solid border-gray-300 rounded-md px-3 py-2 text-gray-600 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 bg-white ${error ? "border-red-500" : ""} ${disabled ? "bg-gray-100 cursor-not-allowed text-gray-500" : ""} ${className}`}
        {...props}
      >
        {/* Placeholder, not selectable */}
        <option value="" disabled hidden>
          {placeholder}
        </option>

        {/* Real options */}
        {finalOptions.map((option) => (
          <option key={option.value} value={option.value}>
            {option.label || option.name}
          </option>
        ))}
      </select>

      {/* Error message */}
      {error && <span className="mt-1 block text-sm text-red-500">{errorMessage}</span>}
    </div>
  );
};

export const TableStatusSelect = ({
  value,
  options = [],
  onChange,
  disabled = false,
  className = ""
}) => {
  // Use our centralized config helper
  const config = getStatusConfig(value);

  return (
    <div
      className={`relative group min-w-[150px] ${className}`}
      onClick={(e) => e.stopPropagation()} // Prevent row click events
    >
      <select
        value={value}
        onChange={(e) => onChange(e.target.value)}
        disabled={disabled}
        className={`w-full appearance-none cursor-pointer rounded-lg border px-8 py-1.5 text-sm font-medium transition-all 
          ${config.bgColor} 
          ${config.textColor} 
          ${config.borderColor} 
          ${config.ringColor}
          hover:shadow-sm focus:outline-none focus:ring-2 focus:ring-opacity-50
          disabled:cursor-not-allowed disabled:opacity-70`}
      >
        {options.map((opt) => (
          <option key={opt} value={opt} className="bg-white text-gray-800">
            {opt}
          </option>
        ))}
      </select>

      {/* The Visual Dot */}
      <div className="absolute left-3 top-1/2 -translate-y-1/2 pointer-events-none">
        <div className={`h-2 w-2 rounded-full ${config.dotColor}`}></div>
      </div>

      {/* The Custom Arrow Icon */}
      <div className="absolute inset-y-0 right-0 flex items-center pr-2 pointer-events-none">
        <svg
          className={`w-4 h-4 ${config.textColor}`}
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
        >
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
        </svg>
      </div>
    </div>
  );
};